import React, {Component} from 'react';
import SVGIcon from '../../../../../../assets/svg-icons/icons';
import Button from '../../../../../shared/library/Button/Button';
import {getGATags} from '../../../../../shared/utilities/GAHelpers';

export default class PhoneButton extends Component {
  state = {
    showPhoneNumber: this.props.isPremium,
  };

  componentDidMount() {
    this.triggerDialogTechWhenReady();
  }

  triggerDialogTechWhenReady() {
    const triggerDialogTech = () => {
      if (window._st) {
        window._st.triggerPageHit();
      }
    };

    document.readyState === 'complete'
      ? triggerDialogTech()
      : window.addEventListener('load', triggerDialogTech());
  }

  phoneIconStyle = {
    top: '10px',
    position: 'relative',
  };

  handlePhoneToggle = event => {
    if (this.state.showPhoneNumber === false) {
      event.preventDefault();
      getGATags({
        eventCategory: 'fhd_phone',
        eventAction: 'fhd_phone_call_click',
        eventLabel: 'viewnumber',
      });
      this.setState({showPhoneNumber: true});
    } else {
      getGATags({
        eventCategory: 'fhd_phone',
        eventAction: 'fhd_phone_call_click',
        eventLabel: this.props.isPremium ? 'callprem' : 'callstandard',
      });
    }
  };

  render() {
    const {showPhoneNumber} = this.state;
    const {phoneNumber, showIcon = true, className} = this.props;
    const phoneButtonClass = className
      ? className
      : 'spaced-button phone-button large-button';
    const clickablePhoneNumber =
      showPhoneNumber && phoneNumber
        ? `tel:${phoneNumber.replace(/[()\- ]/g, '')}`
        : null;
    const phoneButtonContents = showPhoneNumber
      ? phoneNumber
      : 'View Phone Number';

    return (
      <Button
        className={phoneButtonClass}
        href={clickablePhoneNumber}
        action={this.handlePhoneToggle}
      >
        {showIcon && (
          <SVGIcon
            style={this.phoneIconStyle}
            size="24px"
            fill="currentColor"
            name="phone"
          />
        )}
        {phoneButtonContents}
      </Button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Shared/PhoneButton/index.js